
  import { defineComponent } from 'vue';

  import ContextMenu from '@/common/components/redesigned/ContextMenu/ContextMenu.vue';
  import ContextMenuItem from '@/common/components/redesigned/ContextMenu/ContextMenuItem.vue';

  export default defineComponent({
    name: 'GlobalContextMenu',
    components: {
      ContextMenu,
      ContextMenuItem,
    },
    props: {
      isVisible: {
        type: Boolean,
        default: false,
      },
      position: {
        type: Object as () => { top: number; right: number },
        required: true,
      },
    },
    emits: ['action', 'close', 'selectProductsGroups'],
    methods: {
      handleClose() {
        this.$emit('close');
      },
      handleAction(codeLength: number) {
        this.$emit('action', codeLength);
        this.handleClose();
      },
      handleSelectProductsGroups() {
        this.$emit('selectProductsGroups');
        this.handleClose();
      },
    },
  });
